const routes = [
  // 外教管理
  {
    // 外教管理列表
    path: "/foreignManage",
    name: "foreignManage",
    meta: {
      title: "外教管理",
      volcengine: false,
    },
    component: () => import("@/pages/lsForeign/foreignManage/index.vue")
  },
  {
    // 外教详情
    path: "/foreign/info",
    name: "foreign/info",
    meta: {
      title: "外教详情",
      volcengine: true
    },
    component: () => import("@/pages/lsForeign/foreignManage/detail.vue")
  },
  {
    // 外教查看时间
    path: "/foreign/showTime",
    name: "foreign/showTime",
    meta: {
      title: "查看时间",
      volcengine: true
    },
    component: () => import("@/pages/lsForeign/foreignManage/showTime.vue")
  },
];
export default routes;
